/**
 * Shared constants for the admin UILM sync flow.
 *
 * Kept in one place so we can change defaults (supported locales, batch
 * sizes, etc.) without grepping the codebase.
 */

/** The locale we treat as the canonical source for translations. */
export const DEFAULT_LANGUAGE_CULTURE = 'en-US';

/** Locales the admin sync flow knows how to populate. */
export const SUPPORTED_CULTURES = ['en-US', 'de-DE'] as const;
export type SupportedCulture = (typeof SUPPORTED_CULTURES)[number];

/**
 * Max keys per `Key/SaveKeys` batch. The UILM endpoint has no documented
 * upper limit, but very large bodies risk gateway timeouts — chunk to keep
 * each request small and provide useful progress reporting.
 */
export const UILM_KEY_BATCH_SIZE = 100;

/**
 * Page size for `Key/Gets` when fetching every key in a module. Templates
 * with hundreds of fields are rare but possible; bump this rather than
 * paginating if a template ever overflows.
 */
export const UILM_FETCH_PAGE_SIZE = 1000;
